import { z } from "zod";

export const formTypeSchema = z.enum(["survey", "quote", "contact", "coverage"]);

export const submissionSchema = z.object({
  form_type: formTypeSchema,
  name: z.string().trim().max(200).optional().or(z.literal("")),
  phone: z.string().trim().max(50).optional().or(z.literal("")),
  email: z
    .string()
    .trim()
    .max(320)
    .email({ message: "Please enter a valid email address" })
    .optional()
    .or(z.literal("")),
  postcode: z.string().trim().max(20).optional().or(z.literal("")),
  service_of_interest: z.string().trim().max(200).optional().or(z.literal("")),
  services_interested: z.array(z.string().trim().max(120)).max(20).optional(),
  homeowner_status: z.string().trim().max(50).optional().or(z.literal("")),
  message: z.string().trim().max(5000).optional().or(z.literal("")),
  source_page: z.string().trim().max(500).optional().or(z.literal("")),
  gclid: z.string().trim().max(500).optional().or(z.literal("")),
  // Password managers can populate this hidden field. The server decides
  // whether it represents spam using the presence of genuine contact details.
  honeypot: z.string().max(500).optional(),
});

export type SubmissionInput = z.infer<typeof submissionSchema>;
